import * as angular from 'angular';
import {IHttpPromise, IHttpService, IPromise} from 'angular';
import TSApplicationProperty from '../../models/TSApplicationProperty';

export class ApplicationPropertyRS {
    serviceURL: string;
    http: IHttpService;

    static $inject = ['$http', 'REST_API'];

    /* @ngInject */
    constructor($http: IHttpService, REST_API: string) {
        this.serviceURL = REST_API + 'application-properties';
        this.http = $http;

    }

    getByName(name: string): IPromise<TSApplicationProperty> {
        return this.http.get(this.serviceURL + '/key/' + encodeURIComponent(name), {cache: true}).then((response) => {
            return <TSApplicationProperty>response.data;
            //(response: any) => this.ebeguRestUtil.parseApplicationProperty(new TSApplicationProperty(), response.data)
        });
    }

    isDevMode(): IPromise<boolean> {
        return this.http.get<boolean>(this.serviceURL + '/public/devmode', {cache: true}).then((response) => {
            return response.data;
        });
    }

    getVereinbarungValidYears(): IPromise<number> {
        return this.http.get<number>(this.serviceURL + '/public/vereinbarungvalidyears', {cache: true}).then((response) => {
            return response.data;
        });
    }

    isDummyMode(): IPromise<boolean> {
        return this.http.get<boolean>(this.serviceURL + '/public/dummy', {cache: true}).then((response) => {
            return response.data;
        });
    }

    getBackgroundColor(): IPromise<TSApplicationProperty> {
        return this.http.get(this.serviceURL + '/public/background', {cache: true}).then((response: any) => {
            return <TSApplicationProperty> response.data;
        });
    }

    getPiwikSiteId(): IPromise<TSApplicationProperty> {
        return this.http.get(this.serviceURL + '/public/piwik', {cache: true}).then((response: any) => {
            return <TSApplicationProperty> response.data;
        });
    }

    getSentryEnvName(): IPromise<TSApplicationProperty> {
        return this.http.get(this.serviceURL + '/public/sentryenv', {cache: true}).then((response: any) => {
            return <TSApplicationProperty> response.data;
        });
    }

    getRecaptchaSiteKey(): IPromise<string> {
        return this.http.get(this.serviceURL + '/public/captchakey').then((response: any) => {
            return (response && response.data.value) ? response.data.value : undefined;
        });
    }

    create(name: string, value: string | undefined): IPromise<TSApplicationProperty> {
        return this.http.post(this.serviceURL + '/' + encodeURIComponent(name), value, {
            headers: {
                'Content-Type': 'text/plain'
            }
        }).then((response: any) => {
            return new TSApplicationProperty().deserialize(response.data);
        });
    }

    update(name: string, value: string | undefined): IPromise<TSApplicationProperty> {
        return this.http.post(this.serviceURL + '/' + encodeURIComponent(name), value, {
            headers: {
                'Content-Type': 'text/plain'
            }
        }).then((response: any) => {
            return new TSApplicationProperty().deserialize(response.data);
        });
    }

    remove(name: string): IHttpPromise<any> {
        return this.http.delete(this.serviceURL + '/' + encodeURIComponent(name));
    }

    getAllApplicationProperties(): IPromise<TSApplicationProperty[]> {
        return this.http.get(this.serviceURL + '/', {cache: true}).then((response: any) => {
            let converter = (jsonString: any) => {
                return new TSApplicationProperty().deserialize(jsonString);
            };
            if (angular.isArray(response.data)) {
                return response.data.map(converter);
            }
            return [];
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/admin/service/applicationPropertyRS.rest.ts